<template>
  <v-container>
    <MvManager />
  </v-container>
</template>

<script>
import MvManager from '@components/mv_manager';
import { VOCABULARIES } from '@/config/firestore';
import addNamedCollection from '@/mixins/firestore/addNamedCollection';

export default {
  name: 'MyVocabulary',
  components: {
    MvManager,
  },
  mixins: [addNamedCollection],
  methods: {
    async initDatabase() {
      const db = await this.$firestore.collection(VOCABULARIES).doc(this.userUid).get().then((doc) => doc);
      if (!db.exists) {
        await this.addNamedCollection(VOCABULARIES, {});
      }
    },
  },
  async created() {
    await this.initDatabase();
  },
};
</script>
